//require('dotenv').config();//instatiate environment variables
const defaultConfig = {
  baseDir: "/",
  port: "3000",
  host: "https://pgplgroup.com/premgreen-admin-api",
  //host:"http://localhost:3000/premgreen-admin-api",
  //host: "http://103.214.128.216/premgreen-admin-api",
  dir: "/",
  defaultLimit: 10,
  tokenExpTime: 10800, //Time in Second
  //logoPath: process.env.REACT_APP_BASE_Logo_Path,
  //localDocFilePath:"http://localhost/prem-green/node-api/uploads/",
  localDocFilePath: `https://pgplgroup.com/premgreen-admin-api`,
  mapKey: "AIzaSyAulocN3-au3O0aGWy2k1k-Ft8n1mwGqbY",
  fileUploadSizeLabel: "2MB", //size in bytes 
  fileUploadSize: (2 * 1024 * 1024),
  imageUploadType: [".jpg", ".gif", ".png", ".jpeg"],
  foodics_url: process.env.REACT_APP_BASE_FOODICS_URL,
  dateFormat: "MMM D, yyyy",
  orderStatusList: [
    { value: "pending", label: "Pending" },
    { value: "partial", label: "Partial Complete" },
    { value: "completed", label: "Completed" },
    { value: "cancelled", label: "Cancelled" }
  ],
  generalStatus: [
    { label: "Yes", value: "yes" },
    { label: "No", value: "no" }
  ],
  status: [
    { value: "active", label: "Active" },
    { value: "inactive", label: "Inactive" }
  ],

  gender: [
    { label: "Male", value: "male" },
    { label: "Female", value: "female" }
  ],
  partners: {
    "retailers": { label: "Retailers", value: "retailers" },
    "distributors": { label: "Distributors", value: "distributors" },
    "superStockists": { label: "Super Stockists", value: "superStockists" },
    "csa": { label: "CSA", value: "csa" }
  },
  parentUserLabel: {
    "retailers": 'Distributors',
    "distributors": 'Super Stockists',
    "superStockists": 'CSA'
  },
  leavesStatus: [
    { label: "Pending", value: "pending" },
    { label: "Reject", value: "reject" },
    { label: "Approve", value: "approve" }
  ],
  userType: [
    { label: "Retailers", value: "retailers" },
    { label: "Distributors", value: "distributors" },
    { label: "Super Stockists", value: "superStockists" },
    { label: "CSA", value: "csa" },
    { label: "Staff", value: "staff" }
  ],
  dashboardUserType: [
    { label: "Retailers", value: "retailers" },
    { label: "Distributors", value: "distributors" },
    { label: "Super Stockists", value: "superStockists" },
    { label: "CSA", value: "csa" }
  ],
  unitList: [
    { label: "PC", value: "pc" },
    { label: "PKT", value: "pkt" },
    { label: "JAR", value: "jar" },
    { label: "LADI", value: "ladi" },
    { label: "BOX", value: "box" },
    { label: "BAG", value: "bag" }
  ],
  orderUserType: [
    { label: "CSA", value: "csa" },
    { label: "Super Stockists", value: "superStockists" },
    { label: "Distributors", value: "distributors" },
  ],
  schemeType: [
    { label: "Primary", value: "primary" },
    { label: "Secondary", value: "secondary" },
  ],
  attendanceType: {
    "A": "Absent",
    "L": "Leave",
  }
}

export default defaultConfig;